var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 1.9959C13.7189 1.77703 13.9787 1.60341 14.2647 1.48496C14.5506 1.36651 14.8571 1.30554 15.1667 1.30554C15.4762 1.30554 15.7827 1.36651 16.0687 1.48496C16.3546 1.60341 16.6145 1.77703 16.8333 1.9959C17.0522 2.21477 17.2258 2.4746 17.3443 2.76057C17.4627 3.04654 17.5237 3.35304 17.5237 3.66256C17.5237 3.97209 17.4627 4.27859 17.3443 4.56456C17.2258 4.85052 17.0522 5.11036 16.8333 5.32923L5.58333 16.5792L1 17.8292L2.25 13.2459L13.5 1.9959Z",
    stroke: "#024E7D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.0b4feb69fd35819c2262d30f27ff0c4d.svg";
export { ForwardRef as ReactComponent };